import { format, isSameDay } from 'date-fns';

const formatRangeText = (
  [start, end]: [Date | null | undefined, Date | null | undefined],
  dateFormat: string,
): string => {
  if (!start) return '';
  const from = format(start, dateFormat);
  return !end || isSameDay(start, end) ? from : `${from} - ${format(end, dateFormat)}`;
};

export default formatRangeText;
